var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"mt-4",attrs:{"header":"Afgerond"}},[_c('page-snippet',{attrs:{"name":"api-success"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }